import {
  CAMPAIGN_DELIVERY_TONES,
  CampaignCard,
  CampaignCardAction,
  CampaignCardBody,
  CampaignCardHeader,
} from '#/entities/campaign'
import type {
  CampaignDeliveryBreakdown,
  CampaignDeliveryTone,
} from '#/entities/campaign'

const SEGMENT_FILL: Record<CampaignDeliveryTone, string> = {
  [CAMPAIGN_DELIVERY_TONES.delivered]: 'bg-campaign-done',
  [CAMPAIGN_DELIVERY_TONES.hardBounce]: 'bg-campaign-stopped',
  [CAMPAIGN_DELIVERY_TONES.softBounce]: 'bg-campaign-soft-bounce',
  [CAMPAIGN_DELIVERY_TONES.blocked]: 'bg-campaign-blocked',
}

interface CampaignDeliveryCardProps {
  breakdown: CampaignDeliveryBreakdown
  /** Opens the drill-down listing who this channel could not reach. */
  onSeeAll: () => void
}

/**
 * What happened to the messages, as one proportional bar plus its key. Used for
 * both the email and the SMS side — same shape, different vocabulary.
 */
export function CampaignDeliveryCard({
  breakdown,
  onSeeAll,
}: CampaignDeliveryCardProps) {
  return (
    <CampaignCard>
      <CampaignCardHeader
        label={breakdown.label}
        action={
          <CampaignCardAction onClick={onSeeAll}>
            {breakdown.actionLabel}
          </CampaignCardAction>
        }
      />
      <CampaignCardBody>
        <div className="flex items-center gap-0.5">
          {breakdown.segments.map((segment) => (
            <span
              key={segment.key}
              aria-hidden="true"
              className={`h-2 rounded-xs ${SEGMENT_FILL[segment.tone]}`}
              style={{ width: `${(segment.share * 100).toFixed(2)}%` }}
            />
          ))}
        </div>
        <ul className="flex flex-wrap items-center gap-x-4 gap-y-1.5">
          {breakdown.segments.map((segment) => (
            <li key={segment.key} className="flex items-center gap-1.75">
              <span
                aria-hidden="true"
                className={`size-1.5 rounded-full ${SEGMENT_FILL[segment.tone]}`}
              />
              <span className="text-xs text-gray-500">{segment.label}</span>
            </li>
          ))}
        </ul>
        <p className="text-xs text-gray-300">{breakdown.note}</p>
      </CampaignCardBody>
    </CampaignCard>
  )
}
